import apiClient from "./ApiService";
import { PATH_OCCUPATIONS } from "../config/env";

export const getOccupations = async()=>{
    return await apiClient.get(PATH_OCCUPATIONS);
}
export default getOccupations;